import type { ComponentProps } from 'react';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@repo/lib/cn';

function TooltipProvider(tooltipProviderProps: ComponentProps<typeof TooltipPrimitive.Provider>) {
  const { delayDuration = 300, ...props } = tooltipProviderProps;
  return <TooltipPrimitive.Provider data-slot="tooltip-provider" delayDuration={delayDuration} {...props} />;
}

function Tooltip(tooltipProps: ComponentProps<typeof TooltipPrimitive.Root>) {
  const { ...props } = tooltipProps;
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root data-slot="tooltip" {...props} />
    </TooltipProvider>
  );
}

function TooltipTrigger(tooltipTriggerProps: ComponentProps<typeof TooltipPrimitive.Trigger>) {
  const { ...props } = tooltipTriggerProps;
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}
function TooltipContent(tooltipContentProps: ComponentProps<typeof TooltipPrimitive.Content>) {
  const { className, sideOffset = 8, children, ...props } = tooltipContentProps;
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          'bg-gray text-gray-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-sm px-2 py-1 text-xs text-balance',
          className
        )}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow className="bg-gray fill-gray z-50 size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-[2px]" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
